module.exports = __webpack_public_path__ + "static/media/kerry.919ba97b.png";